<template>
    <div class="search-insureres">
        <v-autocomplete
            v-model="insurerCodes"
            :items="items"
            :search-input.sync="search"
            class="rounded-0"
            label="Organisme assureur"
            outlined
            dense
            hide-selected
            hide-details
            append-icon="mdi-chevron-down"
            item-text="label"
            item-value="code"
            no-data-text="Aucune convention collective ne correspond à votre recherche"
            :clearable="true"
        />
    </div>
</template>

<script>
import { get } from "lodash";

export default {
    props: ["value", "insurers"],
    data() {
        return {
            insurerCodes: null,
            search: null,
        };
    },
    mounted() {
        this.insurerCodes = this.value;
    },
    watch: {
        async insurerCodes(value) {
            this.$emit("input", value);
        },
        value(_value) {
            this.insurerCodes = _value;
        },
    },
    computed: {
        items() {
            return Object.keys(this.insurers).map(key => ({
                code: key,
                label: get(this.insurers, `${key}.label`, ""),
            }));
        },
    },
};
</script>

<style lang="sass" scoped>
.search-insureres
    margin: 8px
</style>
